export const berechnungsartMonat = {
  durchschnitt: 'durchschnitt',
  exakt: 'exakt',
} as const;

export type BerechnungsartMonat = keyof typeof berechnungsartMonat;
